/** Presentation only: component validation and normalization belong to the backend. */
export function panelExportText(ui, state) {
  if (ui?.version !== 1) return '';
  const panel = ui.panel;
  if (!state) return ui.text;
  if (panel.type === 'checklist') {
    return [panel.title, panel.description, ...panel.items.map((item) =>
      `- [${state.checked?.includes(item.id) ? 'x' : ' '}] ${item.label}${item.detail ? `：${item.detail}` : ''}`
    )].filter(Boolean).join('\n');
  }
  if (panel.type === 'form') {
    const filled = panel.fields.filter((field) => state.values?.[field.id]);
    return [ui.text, filled.length ? `已填写：\n${filled.map((field) => `${field.label}：${state.values[field.id]}`).join('\n')}` : ''].filter(Boolean).join('\n\n');
  }
  const options = panel.type === 'choices' ? panel.options : panel.type === 'comparison' ? panel.columns : panel.type === 'cards' ? panel.items : [];
  const selected = options.filter((item) => state.selected?.includes(item.id)).map((item) => item.label || item.title);
  return [ui.text, selected.length ? `已选择：${selected.join('、')}` : ''].filter(Boolean).join('\n\n');
}
